<template>
  <div class="row">
    <div class="col-md-12" style="margin: -15px;">
      <div class="card">
        <div class="card-header" style="background-color: #DBECDB;">
          <h5 class="card-title">Reporte de Stock - Ventanilla</h5>
        </div>
        <div class="card-body">
          <!-- Filtros -->
          <div class="row mb-4">
            <div class="col-md-2">
              <label class="form-label">Fecha Desde</label>
              <input
                v-model="filters.fecha_desde"
                type="date"
                class="form-control"
              >
            </div>
            <div class="col-md-2">
              <label class="form-label">Fecha Hasta</label>
              <input
                v-model="filters.fecha_hasta"
                type="date"
                class="form-control"
              >
            </div>
            <div class="col-md-2">
              <label class="form-label">Item</label>
              <select
                v-model="filters.item_id"
                class="form-select"
              >
                <option value="">Todos</option>
                <option v-for="item in filterOptions.items" :key="item.id" :value="item.id">
                  {{ item.nombre_item }}
                </option>
              </select>
            </div>
            <div class="col-md-2">
              <label class="form-label">Serie</label>
              <select
                v-model="filters.serie"
                class="form-select"
              >
                <option value="">Todas</option>
                <option v-for="serie in filterOptions.series" :key="serie" :value="serie">
                  {{ serie }}
                </option>
              </select>
            </div>
            <div class="col-md-2">
              <label class="form-label">Area</label>
              <select
                v-model="filters.id_area"
                class="form-select"
              >
                <option value="">Todos</option>
                <option value="28">Ventanilla 1</option>
                <option value="29">Ventanilla 2</option>
                <option value="30">Ventanilla 3</option>
                <option value="31">Ventanilla 4</option>
                <!--
                <option v-for="origen in filterOptions.origenes" :key="origen" :value="origen">
                  {{ origen }}
                </option>
                -->
              </select>
            </div>
            <div class="col-md-2 d-flex align-items-end">
              <div class="d-flex gap-2">
                <BButton
                  @click="generateReport"
                  variant="primary"
                  :disabled="loading"
                >
                  <i class="fa fa-search me-1"></i> Generar
                </BButton>
                <BButton
                  @click="clearFilters"
                  variant="secondary"
                >
                  <i class="fa fa-times me-1"></i> Limpiar
                </BButton>
                <BButton
                  @click="exportPDF"
                  variant="danger"
                  :disabled="!reportData.length || loadingPDF"
                >
                  <template v-if="loadingPDF">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Generando...
                  </template>
                  <template v-else>
                    <i class="fa fa-file-pdf me-1"></i> PDF
                  </template>
                </BButton>
                <!--
                <BButton
                  @click="exportExcel"
                  variant="success"
                  :disabled="!reportData.length"
                >
                  <i class="fa fa-file-excel me-1"></i> Exportar Excel
                </BButton>
                -->
              </div>
            </div>
          </div>
          <!--
          <div class="row mb-4">
            <div class="col-md-3">
              <label class="form-label">Área</label>
              <select
                v-model="filters.area_id"
                class="form-select"
              >
                <option value="">Todas</option>
                <option v-for="area in filterOptions.areas" :key="area.id" :value="area.id">
                  {{ area.nombre_area }}
                </option>
              </select>
            </div>
            
          </div>
          -->
          <!-- Loading -->
          <div v-if="loading" class="text-center py-4">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Cargando...</span>
            </div>
            <p class="mt-2">Generando reporte...</p>
          </div>

          <!-- Reporte -->
          <div v-else-if="reportData.length > 0">
            <!-- Resumen -->
            <!--
            <div class="row mb-4">
              <div class="col-md-3">
                <div class="card text-center">
                  <div class="card-body">
                    <h3 class="text-primary">{{ reportData.length }}</h3>
                    <p class="mb-0 text-muted">Items Diferentes</p>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="card text-center">
                  <div class="card-body">
                    <h3 class="text-success">{{ totalCantidadDisponible }}</h3>
                    <p class="mb-0 text-muted">Cantidad Disponible</p>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="card text-center">
                  <div class="card-body">
                    <h3 class="text-warning">{{ totalCantidadCanjeada }}</h3>
                    <p class="mb-0 text-muted">Cantidad Canjeada</p>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="card text-center">
                  <div class="card-body">
                    <h3 class="text-danger">Bs. {{ formatNumber(totalValorDisponible) }}</h3>
                    <p class="mb-0 text-muted">Valor Disponible</p>
                  </div>
                </div>
              </div>
            </div>
            -->
            <!-- Tabla -->
            <div class="table-responsive">
              <table class="table table-sm table-striped table-hover">
                <thead class="table-dark">
                  <tr>
                    <th>#</th>
                    <th>Item</th>
                    <th>Categoría</th>
                    <th>Origen</th>
                    <th>Serie</th>
                    <th>Área</th>
                    <th>Rango Números</th>
                    <th class="text-end">Costo Unitario</th>
                    <th class="text-center">Original</th>
                    <th class="text-center">Canjeada</th>
                    <th class="text-center">Disponible</th>
                    <th class="text-end">Costo Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in reportData" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>
                      <strong>{{ item.nombre_item }}</strong>
                      <br>
                      <small class="text-muted">{{ item.unidad_medida }}</small>
                    </td>
                    <td>{{ item.nombre_categoria || 'N/A' }}</td>
                    <td>{{ item.origen || 'N/A' }}</td>
                    <td class="text-center">
                      <BBadge variant="info">{{ item.serie }}</BBadge>
                    </td>
                    <td>{{ item.area || 'N/A' }}</td>
                    <td>{{ item.rango_numeros || 'N/A' }}</td>
                    <td class="text-end">Bs. {{ formatNumber(item.costo_unitario) }}</td>
                    <td class="text-center">{{ item.cantidad_original }}</td>
                    <td class="text-center">
                      <BBadge variant="warning">{{ item.cantidad_canjeada }}</BBadge>
                    </td>
                    <td class="text-center">
                      <BBadge :variant="item.cantidad_disponible > 0 ? 'success' : 'danger'">
                        {{ item.cantidad_disponible }}
                      </BBadge>
                    </td>
                    <td class="text-end">
                      <strong>Bs. {{ formatNumber(item.costo_total_disponible) }}</strong>
                    </td>
                  </tr>
                </tbody>
                <tfoot class="table-group-divider">
                  <tr class="table-active">
                    <td colspan="7" class="text-end fw-bold">TOTALES:</td>
                    <td class="text-end fw-bold"></td>
                    <td class="text-center fw-bold">{{ totalCantidadOriginal }}</td>
                    <td class="text-center fw-bold">{{ totalCantidadCanjeada }}</td>
                    <td class="text-center fw-bold">{{ totalCantidadDisponible }}</td>
                    <td class="text-end fw-bold text-success">Bs. {{ formatNumber(totalValorDisponible) }}</td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <!-- Estadísticas adicionales -->
            <!--
            <div class="row mt-4">
              <div class="col-md-6">
                <div class="card">
                  <div class="card-header bg-light">
                    <h6 class="mb-0"><i class="fa fa-chart-pie me-2"></i>Distribución por Origen</h6>
                  </div>
                  <div class="card-body">
                    <div v-for="origen in distribucionOrigenes" :key="origen.nombre" class="mb-2">
                      <div class="d-flex justify-content-between">
                        <span>{{ origen.nombre }}:</span>
                        <span>{{ origen.cantidad }} items ({{ origen.porcentaje }}%)</span>
                      </div>
                      <div class="progress" style="height: 8px;">
                        <div class="progress-bar" 
                             :class="getProgressBarClass(origen.nombre)"
                             :style="{ width: origen.porcentaje + '%' }"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="card">
                  <div class="card-header bg-light">
                    <h6 class="mb-0"><i class="fa fa-chart-bar me-2"></i>Resumen por Serie</h6>
                  </div>
                  <div class="card-body">
                    <div v-for="serie in distribucionSeries" :key="serie.nombre" class="mb-2">
                      <div class="d-flex justify-content-between">
                        <span>Serie {{ serie.nombre }}:</span>
                        <span>{{ serie.cantidad }} items</span>
                      </div>
                      <div class="progress" style="height: 8px;">
                        <div class="progress-bar bg-info" 
                             :style="{ width: (serie.cantidad / totalItemsPorSerie) * 100 + '%' }"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            -->
          </div>

          <!-- Sin resultados -->
          <div v-else-if="!loading && reportData.length === 0 && hasSearched" class="text-center py-5">
            <i class="fa fa-chart-bar fa-3x text-muted mb-3"></i>
            <h5 class="text-muted">No hay datos para mostrar</h5>
            <p class="text-muted">No se encontraron registros con los filtros aplicados</p>
          </div>

          <!-- Estado inicial -->
          <div v-else-if="!loading && !hasSearched" class="text-center py-5">
            <i class="fa fa-chart-line fa-3x text-primary mb-3"></i>
            <h5 class="text-primary">Reporte de Stock</h5>
            <p class="text-muted">Selecciona los filtros y genera el reporte para ver la información</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BButton, BBadge } from 'bootstrap-vue-3';

// Datos
const loading = ref(false);
const loadingPDF = ref(false);
const reportData = ref([]);
const filterOptions = ref({
  items: [],
  areas: [],
  series: [],
  origenes: []
});
const hasSearched = ref(false);

// Filtros
const filters = ref({
  fecha_desde: '',
  fecha_hasta: '',
  item_id: '',
  serie: '',
  origen: '',
  area_id: ''
});

// Watcher para actualizar fecha_hasta cuando se cambia fecha_desde
watch(() => filters.value.fecha_desde, (newVal) => {
  if (newVal && !filters.value.fecha_hasta) {
    filters.value.fecha_hasta = newVal;
  }
});

// Computed properties - CORREGIDAS
const totalCantidadOriginal = computed(() => {
  return reportData.value.reduce((sum, item) => {
    return sum + (parseFloat(item.cantidad_original) || 0);
  }, 0);
});

const totalCantidadCanjeada = computed(() => {
  return reportData.value.reduce((sum, item) => {
    return sum + (parseFloat(item.cantidad_canjeada) || 0);
  }, 0);
});

const totalCantidadDisponible = computed(() => {
  return reportData.value.reduce((sum, item) => {
    return sum + (parseFloat(item.cantidad_disponible) || 0);
  }, 0);
});

const totalValorDisponible = computed(() => {
  return reportData.value.reduce((sum, item) => {
    // Asegurar que costo_total_disponible es un número
    const valor = typeof item.costo_total_disponible === 'number' 
      ? item.costo_total_disponible 
      : parseFloat(item.costo_total_disponible) || 0;
    return sum + valor;
  }, 0);
});

// Distribuciones para gráficos
const distribucionOrigenes = computed(() => {
  const origenes = {};
  const total = reportData.value.length;
  
  reportData.value.forEach(item => {
    const origen = item.origen || 'Sin origen';
    if (!origenes[origen]) {
      origenes[origen] = {
        nombre: origen,
        cantidad: 0,
        porcentaje: 0
      };
    }
    origenes[origen].cantidad++;
  });
  
  // Calcular porcentajes
  Object.values(origenes).forEach(origen => {
    origen.porcentaje = total > 0 ? ((origen.cantidad / total) * 100).toFixed(1) : 0;
  });
  
  return Object.values(origenes).sort((a, b) => b.cantidad - a.cantidad);
});

const distribucionSeries = computed(() => {
  const series = {};
  
  reportData.value.forEach(item => {
    const serie = item.serie || 'Sin serie';
    if (!series[serie]) {
      series[serie] = {
        nombre: serie,
        cantidad: 0
      };
    }
    series[serie].cantidad++;
  });
  
  return Object.values(series).sort((a, b) => b.cantidad - a.cantidad);
});

const totalItemsPorSerie = computed(() => {
  return distribucionSeries.value.reduce((sum, serie) => sum + serie.cantidad, 0);
});

// Métodos
const fetchFilterOptions = async () => {
  try {
    const [itemsRes, areasRes, seriesRes, origenesRes] = await Promise.all([
      axios.get('/api/items'),
      axios.get('/api/areas'),
      axios.get('/ventanilla/reporte/series'),
      axios.get('/ventanilla/reporte/origenes')
    ]);

    filterOptions.value = {
      items: itemsRes.data.data || itemsRes.data || [],
      areas: areasRes.data.data || areasRes.data || [],
      series: seriesRes.data.data || seriesRes.data || [],
      origenes: origenesRes.data.data || origenesRes.data || []
    };
  } catch (error) {
    console.error('Error al cargar filtros:', error);
    Swal.fire('Error', 'No se pudieron cargar las opciones de filtro', 'error');
  }
};

const generateReport = async () => {
  loading.value = true;
  hasSearched.value = true;
  
  try {
    // Eliminar filtros vacíos
    const params = {};
    Object.keys(filters.value).forEach(key => {
      if (filters.value[key] !== '' && filters.value[key] !== null && filters.value[key] !== undefined) {
        params[key] = filters.value[key];
      }
    });

    const response = await axios.get('/ventanilla/reporte/stock-actual', { params });
    
    if (response.data.success) {
      // Procesar datos para asegurar que sean números
      reportData.value = response.data.data.map(item => ({
        ...item,
        cantidad_original: parseFloat(item.cantidad_original) || 0,
        cantidad_canjeada: parseFloat(item.cantidad_canjeada) || 0,
        cantidad_disponible: parseFloat(item.cantidad_disponible) || 0,
        costo_unitario: parseFloat(item.costo_unitario) || 0,
        costo_total_disponible: parseFloat(item.costo_total_disponible) || 0
      }));
      
      // Actualizar opciones de filtro si vienen en la respuesta
      if (response.data.filters) {
        filterOptions.value = { ...filterOptions.value, ...response.data.filters };
      }
    } else {
      Swal.fire('Error', response.data.message || 'Error al generar el reporte', 'error');
      reportData.value = [];
    }
  } catch (error) {
    console.error('Error al generar reporte:', error);
    
    let errorMessage = 'No se pudo generar el reporte';
    if (error.response?.data?.message) {
      errorMessage = error.response.data.message;
    } else if (error.message) {
      errorMessage = error.message;
    }
    
    Swal.fire('Error', errorMessage, 'error');
    reportData.value = [];
  } finally {
    loading.value = false;
  }
};

const clearFilters = () => {
  filters.value = {
    fecha_desde: '',
    fecha_hasta: '',
    item_id: '',
    serie: '',
    origen: '',
    area_id: ''
  };
  reportData.value = [];
  hasSearched.value = false;
};

const exportPDF = async () => {
  loadingPDF.value = true;
  
  try {
    // Construir parámetros para el PDF
    const params = new URLSearchParams();
    Object.keys(filters.value).forEach(key => {
      if (filters.value[key]) {
        params.append(key, filters.value[key]);
      }
    });

    // Agregar timestamp para evitar caché
    params.append('_t', Date.now());
    const response = await axios.get('ventanilla/reporte/stock-actual/pdf', {
            params,
            responseType: 'blob'
        });
        
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `reporte-valores-${new Date().toISOString().split('T')[0]}.pdf`;
    link.click();
    URL.revokeObjectURL(link.href);
    /*    
    const url = `/api/ventanilla/reporte/stock-actual/pdf?${params.toString()}`;
    
    // Abrir en nueva pestaña
    const newWindow = window.open(url, '_blank');
    
    if (!newWindow) {
      Swal.fire('Advertencia', 'Por favor permite popups para descargar el PDF', 'warning');
    }
    */
  } catch (error) {
    console.error('Error al exportar PDF:', error);
    Swal.fire('Error', 'No se pudo generar el PDF', 'error');
  } finally {
    loadingPDF.value = false;
  }
};

const exportExcel = async () => {
  try {
    // Crear datos para Excel
    const headers = [
      'Item',
      'Unidad',
      'Categoría',
      'Origen',
      'Serie',
      'Área',
      'Rango Números',
      'Costo Unitario',
      'Cantidad Original',
      'Cantidad Canjeada',
      'Cantidad Disponible',
      'Costo Total Disponible'
    ];

    const data = reportData.value.map(item => [
      item.nombre_item,
      item.unidad_medida,
      item.nombre_categoria || 'N/A',
      item.origen || 'N/A',
      item.serie,
      item.area || 'N/A',
      item.rango_numeros || 'N/A',
      item.costo_unitario,
      item.cantidad_original,
      item.cantidad_canjeada,
      item.cantidad_disponible,
      item.costo_total_disponible
    ]);

    // Agregar totales
    data.push([
      '', '', '', '', '', '',
      'TOTALES',
      '',
      totalCantidadOriginal.value,
      totalCantidadCanjeada.value,
      totalCantidadDisponible.value,
      totalValorDisponible.value
    ]);

    // Convertir a CSV
    const csvContent = [
      headers.join(','),
      ...data.map(row => row.map(cell => {
        // Escapar comillas y comas
        const cellStr = String(cell);
        return `"${cellStr.replace(/"/g, '""')}"`;
      }).join(','))
    ].join('\n');

    // Descargar
    const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `stock-ventanilla-${new Date().toISOString().split('T')[0]}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    
    Swal.fire('Éxito', 'Archivo Excel generado correctamente', 'success');
    
  } catch (error) {
    console.error('Error al exportar Excel:', error);
    Swal.fire('Error', 'No se pudo exportar a Excel', 'error');
  }
};

const formatNumber = (number) => {
  // Asegurar que es un número
  const num = typeof number === 'number' ? number : parseFloat(number) || 0;
  
  return new Intl.NumberFormat('es-BO', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(num);
};

const getProgressBarClass = (origen) => {
  const classes = {
    'DDE': 'bg-primary',
    'MINEDU': 'bg-success',
    'Sin origen': 'bg-secondary'
  };
  return classes[origen] || 'bg-info';
};

// Inicialización
onMounted(() => {
  fetchFilterOptions();
  
  // Opcional: establecer fechas por defecto (mes actual)
  const today = new Date();
  const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
  
  // Formato YYYY-MM-DD
  filters.value.fecha_desde = firstDay.toISOString().split('T')[0];
  filters.value.fecha_hasta = today.toISOString().split('T')[0];
  
  // Opcional: generar reporte automáticamente
  // setTimeout(() => generateReport(), 1000);
});
</script>

<style scoped>
.card-header {
  background-color: #DBECDB;
}

.table th {
  font-weight: 600;
  font-size: 0.85rem;
}

.table td {
  font-size: 0.85rem;
  vertical-align: middle;
}

.table tfoot {
  border-top: 2px solid #dee2e6;
}

.badge {
  min-width: 40px;
  font-size: 0.75em;
}

.progress {
  background-color: #e9ecef;
  border-radius: 0.25rem;
}

.progress-bar {
  border-radius: 0.25rem;
  transition: width 0.6s ease;
}

/* Estilos responsivos */
@media (max-width: 768px) {
  .table-responsive {
    font-size: 0.75rem;
  }
  
  .btn {
    margin-bottom: 0.5rem;
    font-size: 0.85rem;
  }
  
  .form-label {
    font-size: 0.85rem;
  }
}
</style>